/**
 * Created by alex.y on 9/22/2017.
 */
import {Injectable} from "@angular/core";
import {SearchResponse} from "../../../objects/responses/searchResponse";
import {ReportService} from "../../../services/reportService";
import {BaseResponse} from "../../../objects/common/baseResponse";
import {TotalFeeResponse} from "../../../objects/report/totalFeeResponse";
import {ReportSearchRequest} from "../../../objects/requests/reportSearchRequest";
import {ReportType} from "../../../objects/report/reportType";

@Injectable()
export class TotalAmountReportResolver {

    constructor(private reportService: ReportService) {
    }

    public resolve(): Promise<BaseResponse<Array<TotalFeeResponse>>> {

        let reportSearch = new ReportSearchRequest();
        reportSearch.StartDate =  null;
        reportSearch.EndDate =  null;
        reportSearch.ReportType = ReportType.TotalFee;

        return this.reportService.getTotalFee(reportSearch).then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/reports/totalAmount/totalAmountReport.resolver.ts